import { getObjectBindingsPort, getObjectEventsPort, OBJECT_EVENTS_PORT } from '../../Hasp/properties/v2/logic/index.js';
import { logicDomain } from '../../logic/logicDomain.js';
import { pageLogicSources } from '../../logic/pageLogic.js';
import GraphLayer from '../graph/GraphLayer.js';
import { LOGIC_OBJECT_PORT, logicRenderDomain } from './logicScene.js';

/**
 * Logic as a layer domain: event sources carry an `events` port on their
 * right edge; objects a GPIO binding can drive take it on their left edge.
 */
export const logicLayerDomain = Object.freeze({
    ...logicDomain,
    ...logicRenderDomain,
    sources: pageLogicSources,
    objectPorts: node => {
        const bindings = getObjectBindingsPort(node);
        return [
            ...(bindings ? [{ id: bindings.id, dir: 'in', side: 'left', port: bindings }] : []),
            ...(getObjectEventsPort(node) ? [{ ...LOGIC_OBJECT_PORT, port: OBJECT_EVENTS_PORT }] : []),
        ];
    },
});

/** Overlay layer for the active page's event/action nodes (see GraphLayer). */
export default class LogicLayer extends GraphLayer {
    constructor({ objectLayer }) {
        super({ objectLayer, domain: logicLayerDomain });
    }
}
